import React from 'react';
import { DocPageLayout } from '../../components/DocPageLayout';
import { InfoBox } from '../../components/InfoBox';
interface CheckoutFeaturesPageProps {
  onNavigate?: (pageId: string) => void;
}
export function CheckoutFeaturesPage({
  onNavigate
}: CheckoutFeaturesPageProps) {
  return <DocPageLayout title="Features" data-id="element-1195">
      <div className="text-sm text-gray-500 mb-6 -mt-8" data-id="element-1196">
        <button onClick={() => onNavigate?.('overview')} className="hover:underline text-orange-600" data-id="element-1197">
          Overview
        </button>{' '}
        &gt;{' '}
        <button onClick={() => onNavigate?.('checkout')} className="hover:underline text-orange-600" data-id="element-1198">
          &lt;&lt;checkout&gt;&gt;
        </button>{' '}
        &gt; Features
      </div>

      <p className="text-gray-700 mb-8" data-id="element-1199">
        The &lt;&lt;checkout&gt;&gt; integration supports a variety of advanced
        features to enhance your payment flow and improve conversion rates.
      </p>

      <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1200">
        3D Secure Authentication
      </h2>
      <p className="text-gray-700 mb-4" data-id="element-1201">
        3D Secure (3DS) adds an additional layer of authentication for card
        payments. The checkout automatically handles the 3DS challenge flow when
        required by the issuing bank, including support for 3DS2.
      </p>

      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-1202">
        Tokenization
      </h2>
      <p className="text-gray-700 mb-4" data-id="element-1203">
        Enable tokenization to allow payers to save their card details for
        future purchases. When tokenization is enabled, the checkout displays a
        "Save card" option to the payer.
      </p>

      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-1204">
        Dynamic Currency Conversion (DCC)
      </h2>
      <p className="text-gray-700 mb-4" data-id="element-1205">
        DCC allows international cardholders to see the transaction amount in
        their home currency. The checkout automatically presents the DCC offer
        when available.
      </p>

      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-1206">
        Alternative Payment Methods
      </h2>
      <p className="text-gray-700 mb-4" data-id="element-1207">
        The checkout supports various alternative payment methods in addition to
        card payments, including:
      </p>
      <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4 mb-6" data-id="element-1208">
        <li data-id="element-1209">PayPal</li>
        <li data-id="element-1210">Apple Pay</li>
        <li data-id="element-1211">Google Pay</li>
        <li data-id="element-1212">Alipay</li>
        <li data-id="element-1213">ACH Direct Debit</li>
        <li data-id="element-1214">Gift Cards</li>
      </ul>

      <InfoBox type="info" title="Payment Method Availability" data-id="element-1215">
        Available payment methods depend on your merchant configuration and the
        payer's region. Contact your account manager to enable additional
        payment methods.
      </InfoBox>

      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-1216">
        Order Summary
      </h2>
      <p className="text-gray-700 mb-4" data-id="element-1217">
        Display a detailed order summary on the payment page, including line
        items, taxes, and shipping costs to give payers confidence in their
        purchase.
      </p>
    </DocPageLayout>;
}